import { render } from "./UsageMetrics.vue?vue&type=template&id=78a4efcf&scoped=true"
import script from "./UsageMetrics.vue?vue&type=script&lang=js"
export * from "./UsageMetrics.vue?vue&type=script&lang=js"

import "./UsageMetrics.vue?vue&type=style&index=0&id=78a4efcf&lang=less&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a4efcf"]])

export default __exports__